import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=1f635e76"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f635e76')) {
      api.createRecord('1f635e76', component.options)
    } else {
      api.reload('1f635e76', component.options)
    }
    module.hot.accept("./Invoice.vue?vue&type=template&id=1f635e76", function () {
      api.rerender('1f635e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/Invoice.vue"
export default component.exports